/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SlideClassificationSimple = {
    readonly id?: number;
    status?: SlideClassificationSimple.status;
    ai_release: string | null;
    readonly created_at?: string;
}

export namespace SlideClassificationSimple {

    export enum status {
        ADDED = 'ADDED',
        SUBMITTED = 'SUBMITTED',
        PENDING = 'PENDING',
        RUNNABLE = 'RUNNABLE',
        STARTING = 'STARTING',
        RUNNING = 'RUNNING',
        SUCCEEDED = 'SUCCEEDED',
        FAILED = 'FAILED',
    }


}
